module.exports = __webpack_public_path__ + "static/media/circulo_FFEED9.d05583c0.svg";